import React from 'react';
import { useState ,useEffect } from 'react';
import "./Login.css"
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import GoogleLogin from "react-google-login";
import FacebookLogin from "react-facebook-login";


import {
  Flex,
  Heading,
  Input,
  Button,
  InputGroup,
  Stack,
  InputLeftElement,
  chakra,
  Box,
  Link,
  Avatar,
  FormControl,
  FormHelperText,
  InputRightElement,
  useToast,
} from "@chakra-ui/react";
import { FaUserAlt, FaLock } from "react-icons/fa";

const CFaUserAlt = chakra(FaUserAlt);
const CFaLock = chakra(FaLock);


 

 

async function loginUser(credentials) {
  return fetch('https://disectotaskproject.herokuapp.com/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
    .then(data => data.json())
 }


export const Login = ({ setToken })=> {
  const [user, setUser] = useState([]);
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const toast = useToast()
  const toastIdRef = React.useRef()

  const handleShowClick = () => setShowPassword(!showPassword);

  const [username, setUserName] = useState();
  const [password, setPassword] = useState();


 
  function addToastForgot() {
    toastIdRef.current = toast({ description: 'We have sent you recovery code on email' })
  }


  function addToast() {
    toastIdRef.current = toast({ description: ' Go for signed up' })
  }
  const responseSuccessGoogle = (response) => {
    console.log(response.profileObj, response.tokenId);
    setUser(response.profileObj, response.tokenId);
    // localStorage.setItem("user", JSON.stringify(response.profileObj));
    navigate("/dashboard");
  };

  const responseErrorGoogle = (response) => {
    console.log(response);
    navigate("/");
  };
  const componentClicked = (response) => {
    console.log(response);
    navigate("/");
  };

  const responseFacebook = (response) => {
    console.log(response.name, response.email, response.picture.data.url);
    setUser(response.name, response.email, response.picture.data.url);
    // localStorage.setItem("user", JSON.stringify(response.name));
    navigate("/");
  };
  useEffect(() => {
    console.log("useState", user);
  }, [responseSuccessGoogle]);

  const handleSubmit = async e => {
    e.preventDefault();

    if(username === "admin@gmail.com" && password== "admin"){
    window.location.href = 'https://task2-lilac.vercel.app/';
    }

    const token = await loginUser({
      username,
      password
    });
    setToken(token);
    navigate('/');
  }

  return(

    <div className="login-wrapper">
   
    <Flex
      flexDirection="column"
      width="100wh"
      height="70vh"
      backgroundColor="#9921e8"
background-image= "linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%)"


      
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Avatar bg="#9921e8" />
        <Heading color="teal.400">Welcome</Heading>
        <Box minW={{ base: "90%", md: "468px" }}>
          <form   onSubmit={handleSubmit} >
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor="whiteAlpha.900"
              boxShadow="md"
            >
              <FormControl>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<CFaUserAlt color="gray.300" />}
                  />
                  <Input type="email" placeholder="email address"  onChange={e => setUserName(e.target.value)}  />
                </InputGroup>
              </FormControl>
              <FormControl>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    color="gray.300"
                    children={<CFaLock color="gray.300" />}
                  />
                  <Input
                  onChange={e => setPassword(e.target.value)} 
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                  />
                  <InputRightElement width="4.5rem">
                    <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                      {showPassword ? "Hide" : "Show"}
                    </Button>
                  </InputRightElement>
                </InputGroup>
                <FormHelperText textAlign="right">
                  <Stack spacing={1}>
                <Button onClick={addToastForgot} type='button' variant='outline'>
        forgot your password?
      </Button>
      </Stack>

                </FormHelperText>
              </FormControl>
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="purple"
                width="full"
              >
                Login
              </Button>
            </Stack>
            <br></br>
            <GoogleLogin
          clientId="783084545362-nbv5flob7ak19200jqvmr33fb3og95ri.apps.googleusercontent.com"
          buttonText="Login with Google"
          onSuccess={responseSuccessGoogle}
          onFailure={responseErrorGoogle}
          expectcssClass="google-button"
          cookiePolicy={"single_host_origin"}
          style={{ backgroundColor: "rgb(25,118,210)" }}
        />
<br></br>
<FacebookLogin
          appId="397198822046839"
          autoLoad={false}
          fields="name,email,picture"
          onClick={componentClicked}
          callback={responseFacebook}
          expectcssClass="facebook-button"
          icon="fa-facebook"
          textButton="Login with Facebook"
          style={{ backgroundColor: "rgb(25,118,210)"}}
        />
          </form>
        </Box>
       <span></span>
      </Stack>
     
    </Flex>





    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
}